// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 76 ? "common" : chunkId) + "." + {"36":"4aec920fd10dacc3","76":"ad42dca7e61b016c","331":"2d3c6fd4a42b09bb","489":"c89465384e11cdbe","995":"efd3fa70ff5bccbc"}[chunkId] + ".js";
};